import { Button, Typography , CircularProgress } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

export const SubmitButtons = ({ submitText, submitCallback, cancelText, cancelCallback , disableBtn , isLoading}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', lg: 'row' }, justifyContent: 'center' }}>

            {cancelText && cancelCallback && <Button variant='contained' color='secondary' onClick={cancelCallback} sx={{ px: 5, backgroundColor: '#fff', color: 'grey.600', mx: 1, my: { xs: 1, lg: 0 } }}>
                <Typography fontSize={15}>  {cancelText}</Typography>
                {isLoading && <CircularProgress color="white" size={22} />}
            </Button>}

            <Button variant='contained' disabled={disableBtn} onClick={submitCallback} sx={{ px: 5, mx: 1, my: { xs: 1, lg: 0 } }}>
                {isLoading == true ? (<CircularProgress color="white" size={22} />) : (<Typography fontSize={15}> {submitText}</Typography>) }
            </Button>

        </Box>
    )
}
